import React from "react";

const Footer = () =>
  <footer className="flex items-center flex-column pb3 pt5 pt7-l pb4-l">
    <div className="h-100 w2 w3-l">
      <img
        className="fit-contain"
        src={require("../images/footer_logo.png")}
        alt=""
      />
    </div>
    <p className="f-xxs ttu black-30 b">Copyright 2017 Gulf Seaboard</p>
  </footer>;

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js